import { createAction } from '@ngrx/store';
import { ConfigurationConfig } from '@/app/_core/domain/models/configuration/configuration.model';

export const enum ConfigurationActionsTypes {
  SetConfiguration = '[Configuration] Set Configuration'
}

export const setConfiguration = createAction(ConfigurationActionsTypes.SetConfiguration, ({ configuration }: { configuration: ConfigurationConfig }) => ({
  payload: { configuration }
}));
